import { getInit } from "./InitModelFilter";
import ModelFilter from "./components/lexus/ModelFilter";

// Webpack entry point for ModelFilter Lexus.
export const init = getInit(ModelFilter);
